module.exports = __webpack_public_path__ + "static/media/lobby.294945b8.png";